module.exports = __webpack_public_path__ + "static/img/产品中心-AI设备专家-数据管理.a7016076.png";